import React from 'react';
import HeaderCom from "../../Components/Header/HeaderCom";
import IPlogger from "../../Components/IPlogger/IPlogger";
import Footer from "../../Components/Footer/Footer";
import styled from "styled-components";
import WorksCom from "../../Components/WorksCom";
import SkillsCom from "../../Components/skills/skills";
import AboutCom from "../../Components/about/AboutCom";
import ContactsCom from "../../Components/Contacts/Contacts";
const Home = () => {



    return (
        <Div>
            <HeaderCom/>
            <IPlogger/>
            <div className="opacity-1">
                <WorksCom/>
            </div>
            <div className="opacity-2">
                <SkillsCom/>

            </div>
            <div className="opacity-3">
                <AboutCom/>
            </div>
            <div className="opacity-4">
                <ContactsCom/>
            </div>
            <div className="footer">
                <Footer/>
            </div>
        </Div>
    );
};
const Div = styled.div`
  width: 100%;
  margin: auto;

  .footer {
    position: absolute;
    bottom: -275vh;
    left: 0;
    margin: auto;
    width: 100%;
    opacity: 0; 
    animation: showFooter 2s ease-in-out 16s forwards; 

    @media (max-width: 678px) {
      position: relative;
      bottom: -10vh;
      left: 0;
    }
  }
.opacity-1{
  animation: showContent 2s ease-in-out 10s forwards;
  opacity: 0;
  margin: 150px 0;
}
  .opacity-2{
    animation: showContent 2s ease-in-out 11.5s forwards;
    opacity: 0;
    margin: 100px 0 150px 0;
  }
  .opacity-3{
    animation: showContent 2s ease-in-out 13.5s forwards;
    opacity: 0;
    margin: 150px 0;
  }
  .opacity-4{
    animation: showContent 2s ease-in-out 15.5s forwards;
    opacity: 0;
    margin: 150px 0 0 0;
  }
  @keyframes showFooter {
    to {
      opacity: 1; 
    }
  }
  @keyframes showContent {
    to {
      opacity: 1;
    }
  }



`

export default Home;
